import type { ParsedUrlQuery } from 'querystring';
import {
  bottomRightLatParamKey,
  bottomRightLngParamKey,
  latParamKey,
  lngParamKey,
  topLeftLatParamKey,
  topLeftLngParamKey
} from '@alltrails/filters/utils/exploreSearchParams';
import type { AllTrailsBounds, AllTrailsCenter } from '@alltrails/maps/types/Geo';

export const defaultZoom = 12;

const getSearchParamsMapPosition = (searchParams: ParsedUrlQuery) => {
  let bounds: AllTrailsBounds | undefined;
  const latitudeBottomRight = Number(searchParams[bottomRightLatParamKey]);
  const longitudeBottomRight = Number(searchParams[bottomRightLngParamKey]);
  const latitudeTopLeft = Number(searchParams[topLeftLatParamKey]);
  const longitudeTopLeft = Number(searchParams[topLeftLngParamKey]);
  if (!isNaN(latitudeBottomRight) && !isNaN(longitudeBottomRight) && !isNaN(latitudeTopLeft) && !isNaN(longitudeTopLeft)) {
    bounds = {
      latitudeBottomRight,
      longitudeBottomRight,
      latitudeTopLeft,
      longitudeTopLeft
    };
  }

  let center: AllTrailsCenter | undefined;
  const lat = Number(searchParams[latParamKey]);
  const lng = Number(searchParams[lngParamKey]);
  if (!isNaN(lat) && !isNaN(lng)) {
    center = [lat, lng, defaultZoom];
  }

  return { bounds, center };
};

export default getSearchParamsMapPosition;
